function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgSummer = function SvgSummer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 481.329 481.329",
    style: {
      enableBackground: "new 0 0 481.329 481.329"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB641"
    },
    d: "M161.123,273.72V49.648C161.123,22.232,138.891,0,111.475,0l0,0 C84.051,0,61.827,22.232,61.827,49.648v226.496C24.523,296.456,0.371,337.88,5.435,384.376 c5.456,50.096,46.016,90.736,96.104,96.264c65.888,7.28,121.648-44.112,121.648-108.528 C223.187,328.712,197.803,291.336,161.123,273.72z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E66032"
    },
    d: "M135.555,302.744V216c0-13.256-10.744-24-24-24l0,0c-13.256,0-24,10.744-24,24v88.024 c-25.24,9.976-43.336,34.112-44.376,62.64c-1.392,38.312,29.776,71.656,68.104,72.728c39.672,1.112,72.184-30.72,72.184-70.144 C183.467,338.288,163.387,312.056,135.555,302.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E66032"
    },
    d: "M127.563,183.504c-2.68,0-5.296-1.344-6.808-3.792l-8.712-14.08l-9.888,14.4 c-2.504,3.648-7.472,4.576-11.128,2.064c-3.64-2.496-4.56-7.488-2.064-11.128l16.832-24.496c1.528-2.224,3.984-3.544,6.784-3.472 c2.696,0.072,5.184,1.496,6.608,3.792l15.168,24.496c2.328,3.76,1.168,8.688-2.592,11.016 C130.451,183.12,129.003,183.504,127.563,183.504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E66032"
    },
    d: "M127.563,135.504c-2.68,0-5.296-1.344-6.808-3.792l-8.712-14.08l-9.888,14.4 c-2.504,3.648-7.472,4.576-11.128,2.064c-3.64-2.496-4.56-7.488-2.064-11.128l16.832-24.496c1.528-2.224,3.984-3.56,6.784-3.472 c2.696,0.072,5.184,1.496,6.608,3.792l15.168,24.496c2.328,3.76,1.168,8.688-2.592,11.016 C130.451,135.12,129.003,135.504,127.563,135.504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E66032"
    },
    d: "M127.563,87.504c-2.68,0-5.296-1.344-6.808-3.792l-8.712-14.08l-9.888,14.4 c-2.504,3.648-7.472,4.568-11.128,2.064c-3.64-2.496-4.56-7.488-2.064-11.128l16.832-24.496c1.528-2.224,3.984-3.4,6.784-3.472 c2.696,0.072,5.184,1.496,6.608,3.792l15.168,24.496c2.328,3.76,1.168,8.688-2.592,11.016 C130.451,87.12,129.003,87.504,127.563,87.504z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FCB641"
    },
    cx: 337.795,
    cy: 170.744,
    rx: 138.768,
    ry: 141.256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB641"
    },
    d: "M439.555,312c-4.416,0-8-3.576-8-8v-56c0-4.424,3.584-8,8-8s8,3.576,8,8v56 C447.555,308.424,443.971,312,439.555,312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB641"
    },
    d: "M439.555,360c-4.416,0-8-3.576-8-8v-16c0-4.424,3.584-8,8-8s8,3.576,8,8v16 C447.555,356.424,443.971,360,439.555,360z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB641"
    },
    d: "M359.555,368c-4.416,0-8-3.576-8-8v-56c0-4.424,3.584-8,8-8s8,3.576,8,8v56 C367.555,364.424,363.971,368,359.555,368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB641"
    },
    d: "M359.555,416c-4.416,0-8-3.576-8-8v-16c0-4.424,3.584-8,8-8s8,3.576,8,8v16 C367.555,412.424,363.971,416,359.555,416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB641"
    },
    d: "M271.555,328c-4.416,0-8-3.576-8-8v-24c0-4.424,3.584-8,8-8s8,3.576,8,8v24 C279.555,324.424,275.971,328,271.555,328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB641"
    },
    d: "M271.555,376c-4.416,0-8-3.576-8-8v-16c0-4.424,3.584-8,8-8s8,3.576,8,8v16 C279.555,372.424,275.971,376,271.555,376z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSummer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/summer.3fe3e19c.svg";
export { ForwardRef as ReactComponent };